import { Pipe, PipeTransform } from '@angular/core';
import { ApiEndpoints } from './../../core-modules/constant';


@Pipe({
  name: 'filterPipe'
})
export class DynamicClassPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(value.paperSetType == ApiEndpoints.paperTypePapers){
      return "paper-set-outer-background-exam";
    }else if(value.paperSetType == ApiEndpoints.paperTypeOnline){
      return "paper-set-outer-background-online"
    }else if(value.paperSetType == ApiEndpoints.paperTypeTermtest){
      return "paper-set-outer-background-termtest";
    }else{
      return "paper-set-background-inner"
    }

    // comment for in futer we will need this
    // if (value.clientStatus === undefined) {
      
    //   if (value.accessLevel == 'FREE'){
    //     return "paper-set-background-status-ONGOING";
    //   } else {
        // return "paper-set-background-status-ONLINE";
        // if (value.userInfo.isOnlineExam !== undefined && value.userInfo.isOnlineExam) {
        //   return "paper-set-background-status-ONLINE"
        // } 
        // else if (value.userInfo.clientStatus == 'INPROGRESS' && value.userInfo.accessLevel == 'UNLOCK') {
        //   return "paper-set-background-status-ONGOING";
        // } else if (value.userInfo.accessLevel == 'LOCK') {
        //   return "paper-set-background-status-LOCKED";
        // } else if (value.userInfo.clientStatus == 'COMPLETED' && value.userInfo.accessLevel == 'UNLOCK') {
        //   return "paper-set-background-status-COMPLETE";
        // } else if ((value.userInfo.clientStatus == 'NEW' || value.userInfo.clientStatus == undefined) && value.userInfo.accessLevel == 'UNLOCK') {
        //   return "paper-set-background-status-NEW";
        // } 
        // else {
        //   // kaushalya 2017-10-10 to get the default
        //   return "paper-set-background-status-NEW";
        // }
        // return "paper-set-background-status-LOCKED";
    //   }
    // } else {
    //   if (value.clientStatus == 'INPROGRESS') {
    //     return "paper-set-background-status-ONGOING";
    //   } else if (value.clientStatus == 'LOCK') {
    //     return "paper-set-background-status-LOCKED";
    //   } else if (value.clientStatus == 'COMPLETED') {
    //     return "paper-set-background-status-COMPLETE";
    //   } else if (value.clientStatus == 'NEW') {
    //     return "paper-set-background-status-NEW";
    //   } else {
    //     // kaushalya 2017-10-10 to get the default 
    //     return "paper-set-background-status-NEW";
    //   }
    // }
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/shared/pipe/dynamic-class.pipe.ts